export const companyInfo = {
  name: "HEXA INFOTECH",
  phone: "+91 88801 88488",
  gst: "29AQSPP2291A1ZK",
  address:
    "Ground Floor, No.1050, PRS Lane, OTC Road, Sri Dharmaraya Swamy Temple Road Cross, Bengaluru – 560002, Karnataka, India",
  mapUrl:
    "https://maps.google.com/?q=Ground+Floor,+No.1050,+PRS+Lane,+OTC+Road,+Bengaluru+560002",
};

export const colorRules = [
  {
    title: "1. Contrast",
    detail: "Dark navy text and white backgrounds keep readability strong.",
  },
  {
    title: "2. Hierarchy",
    detail: "Orange highlights guide users first to inquiry actions.",
  },
  {
    title: "3. Consistency",
    detail: "Navy remains the core brand color across headers and links.",
  },
  {
    title: "4. Action",
    detail: "CTA buttons use orange to increase click intent.",
  },
  {
    title: "5. Balance",
    detail: "White space between sections avoids visual fatigue.",
  },
];

export const categories = [
  "All",
  "Networking Accessories",
  "Fiber Optics",
  "Telecom Products",
  "Copper Wire & Cables",
  "Racks & Cabinets",
  "Tools & Testers",
  "Wi-Fi Router",
];

export const products = [
  {
    id: "rj50-connector",
    name: "RJ50 Connector",
    category: "Networking Accessories",
    image:
      "https://images.unsplash.com/photo-1578016980868-197203ff4b02?auto=format&fit=crop&w=900&q=80",
    description:
      "Industrial-grade telecom connector built for durable terminations.",
    specs: ["50 Pins", "Polycarbonate", "Gold plated pin layout"],
  },
  {
    id: "mdf-adsl2-splitter",
    name: "MDF ADSL2+ Splitter",
    category: "Networking Accessories",
    image:
      "https://images.unsplash.com/photo-1615746363486-92cd8c5e0a90?auto=format&fit=crop&w=900&q=80",
    description: "Stable data/voice splitter for dependable broadband lines.",
    specs: ["ADSL2+", "Passive", "Compact"],
  },
  {
    id: "rj11-telephone-sockets",
    name: "RJ11 Telephone Sockets",
    category: "Telecom Products",
    image:
      "https://images.unsplash.com/photo-1573167243872-43c6433b9d40?auto=format&fit=crop&w=900&q=80",
    description: "Reliable socket modules for telecom installations.",
    specs: ["RJ11", "4 Pin", "Easy mount"],
  },
  {
    id: "wr850n-router",
    name: "WR850n TP Link Router",
    category: "Wi-Fi Router",
    image:
      "https://images.unsplash.com/photo-1750711158632-5273ec9b9b86?auto=format&fit=crop&w=900&q=80",
    description: "Wireless router solution for home and office coverage.",
    specs: ["2.4 GHz", "802.11n", "Energy efficient"],
  },
  {
    id: "cat6-patch-cord",
    name: "Commscope CAT 6 Patch Cord",
    category: "Networking Accessories",
    image:
      "https://images.unsplash.com/photo-1604866830893-c13cafa515d5?auto=format&fit=crop&w=900&q=80",
    description: "High-speed patch cable for structured LAN systems.",
    specs: ["250 MHz", "RJ45", "Multiple lengths"],
  },
  {
    id: "impact-punch-tool",
    name: "Impact Punch Down Tool",
    category: "Tools & Testers",
    image:
      "https://images.unsplash.com/photo-1615746363486-92cd8c5e0a90?auto=format&fit=crop&w=900&q=80",
    description: "Precision wire seating tool for MDF and patch panels.",
    specs: ["Manual", "Steel core", "Installer friendly"],
  },
  {
    id: "dlink-lan-tester",
    name: "D Link LAN Cable Tester",
    category: "Tools & Testers",
    image:
      "https://images.unsplash.com/photo-1580894908361-967195033215?auto=format&fit=crop&w=900&q=80",
    description: "Quick testing device for RJ45 and RJ11 cable checks.",
    specs: ["RJ45/RJ11", "Battery powered", "Portable"],
  },
  {
    id: "bmf-rack-frame",
    name: "BMF Rack Frame",
    category: "Racks & Cabinets",
    image:
      "https://images.unsplash.com/photo-1684514038272-d0476d13b7fa?auto=format&fit=crop&w=900&q=80",
    description: "Strong rack frame for communication module housing.",
    specs: ["16 Channel", "Powder coated", "19-inch standard"],
  },
  {
    id: "18u-network-rack",
    name: "18U Network Rack",
    category: "Racks & Cabinets",
    image:
      "https://images.unsplash.com/photo-1744868562210-fffb7fa882d9?auto=format&fit=crop&w=900&q=80",
    description: "Secure cabinet for switches, patch panels, and servers.",
    specs: ["18U", "Steel", "Cable management ready"],
  },
  {
    id: "sc-upc-fast-connector",
    name: "SC UPC Fast Connector",
    category: "Fiber Optics",
    image:
      "https://images.unsplash.com/photo-1607862195121-fd56da766674?auto=format&fit=crop&w=900&q=80",
    description: "Fast-install optical connector designed for FTTH work.",
    specs: ["UPC finish", "Low loss", "Field install"],
  },
  {
    id: "ftth-mini-box",
    name: "FTTH Mini Fiber Optic Box",
    category: "Fiber Optics",
    image:
      "https://images.unsplash.com/photo-1607862195121-fd56da766674?auto=format&fit=crop&w=900&q=80",
    description: "Compact distribution box for fiber termination points.",
    specs: ["Wall mount", "Compact", "Fiber routing support"],
  },
  {
    id: "cat6-utp-cable",
    name: "Cat 6 100 Mtr UTP Cable",
    category: "Copper Wire & Cables",
    image:
      "https://images.unsplash.com/photo-1562976540-1502c2145186?auto=format&fit=crop&w=900&q=80",
    description: "High-performance UTP cable for network rollouts.",
    specs: ["100m", "Copper core", "Consistent throughput"],
  },
];